import React, { useState } from 'react';
import { Nav, Avatar } from 'rsuite';
import { connect } from 'react-redux';
import { FiFileText, FiUser, FiHome as IconHome } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';

import { useI18n } from '../../../../i18n';
import PopupNavItem from './PopupNavItem';
import SettingsMenu from './SettingsMenu';
import NavLinkItem from './NavLinkItem';
import DashboardPage from '../../pages/DashboardPage';
import ReportsPage from '../../pages/ReportsPage';
import ProfileControl from './ProfileControl';
import RecentEventList from '../../share/events/RecentEventList';
import AccountPopup from '../profile/AccountPopup';
import iconBell from '../../../img/icons/bell.png';
import iconReport from '../../../img/icons/report.png';
import iconSettings from '../../../img/icons/settings.png';
import iconQuestion from '../../../img/icons/popup-question.png';
import LangPopupNavItem from './LangPopupNavItem';
import { className, fromProps } from '../../../lib/className';
import { AllRoutes } from 'constants/routes';
import { more, tep } from 'assets/icons';
import { MonitoringMenu } from './monitoring-menu';
import { SvgWrapper } from 'components/atoms/svg-wrapper';
import { TepMenu } from './tep-menu';

import './globalMenu.scss';

const TEP_ROUTES = [AllRoutes.TepManagement, AllRoutes.TepDevicesManagement];

function GlobalMenu(props) {
	const { account, roleMap } = props;

	const { f } = useI18n();

	const { pathname } = useLocation();

	const [showProfile, setShowProfile] = useState(false);
	const [profileAspect, setProfileAspect] = useState();

	const role = roleMap?.[account?.details?.role]?.mnemonics;
	const isIssuesShown = role === 'admin' || role === 'customer';

	return (
		<Nav className={className('global-menu', fromProps(props))}>
			<NavLinkItem to={DashboardPage.Url} title={f('dashboard')}>
				<IconHome size={20} />
			</NavLinkItem>
			<PopupNavItem
				icon={
					<SvgWrapper
						width={22}
						height={22}
						color={TEP_ROUTES.includes(pathname) ? '#79CDD0' : '#99ABB4'}
						details={tep}
					/>
				}
				content={<TepMenu />}
			/>
			{isIssuesShown && (
				<NavLinkItem to={AllRoutes.Issues} title={f('issues')}>
					<FiFileText size={20} />
				</NavLinkItem>
			)}
			<PopupNavItem icon={<img src={iconBell} alt="" />} content={<RecentEventList />} title={f('recent events')} />
			<PopupNavItem
				icon={<SvgWrapper width={22} height={22} color="#99ABB4" details={more} />}
				content={<MonitoringMenu />}
			/>
			<NavLinkItem to={ReportsPage.Url} title={f('reports')}>
				<img src={iconReport} alt="" />
			</NavLinkItem>
			<PopupNavItem icon={<img src={iconSettings} alt="" />} content={<SettingsMenu />} />
			<PopupNavItem
				icon={
					<Avatar circle>
						<FiUser />
					</Avatar>
				}
				title={f('profile')}
				content={
					<ProfileControl
						onClick={(aspect) => {
							setProfileAspect(aspect);
							setShowProfile(true);
						}}
					/>
				}
			/>
			<LangPopupNavItem title={f('select language')} />
			<PopupNavItem icon={<img src={iconQuestion} alt="" />} disabled />
			{showProfile && (
				<AccountPopup aspect={profileAspect} setAspect={setProfileAspect} onClose={() => setShowProfile(false)} />
			)}
		</Nav>
	);
}

export default connect((state) => {
	return {
		account: state.account,
		roleMap: state.registry.roles.map,
	};
})(GlobalMenu);
